import React, { useEffect, useState } from "react";

import { IconInfoSolid, Text, Tooltip } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { OutcomeClassService } from "../../services/OutcomeClassService";
import { Selector } from "./Selector";

export const ClassSelect = ({ selectHandler, selectedItemId }) => {
  const { t } = useTranslation();
  const [classes, setClasses] = useState([]);

  useEffect(() => {
    OutcomeClassService.getOutcomeClasses().then((e) => {
      setClasses(
        e.map((outcomeClass) => {
          return { id: outcomeClass.id, label: outcomeClass.name };
        })
      );
    });
  }, []);

  return (
    <Selector
      id="learning-outcome-class-selector"
      options={classes}
      selectHandler={selectHandler}
      selectedItemId={selectedItemId}
      label={
        <div>
          <Text>{t("analyze.classSelector")}</Text>
          <Tooltip
            renderTip={
              <div style={{ width: 700 }}>
                {t("analyze.classifactionOptionDescriptions")}
              </div>
            }
            placement="top"
            on={["click", "hover", "focus"]}
            color="primary-inverse"
          >
            <IconInfoSolid color="brand" />
          </Tooltip>
        </div>
      }
    />
  );
};
